/**
 * Mapa siteId -> nombre de país (hardcodeado; ampliar en segundo paso si hace falta).
 */
export const SITE_ID_TO_COUNTRY_NAME = {
  MLA: 'Argentina',
  MPE: 'Perú',
  MLB: 'Brasil',
  MCO: 'Colombia',
  MLC: 'Chile',
  MLM: 'México',
  MLU: 'Uruguay',
  MEC: 'Ecuador',
  MGT: 'Guatemala',
  MPN: 'Panamá',
  MRD: 'República Dominicana',
  MSV: 'El Salvador',
  MHN: 'Honduras',
  MNI: 'Nicaragua',
  MCR: 'Costa Rica',
  MBG: 'Bolivia',
  MPY: 'Paraguay',
  MPV: 'Venezuela',
};

/**
 * Normaliza un artículo devuelto por getReportData al formato esperado por
 * Resumen, Details, filtros y ExportExcel (formato legacy de updateItemsNoticed).
 * @param {Object} article - Item con item_id, title, id, current_status, fecha, auditor, seller_name, seller_id, currency, price, href, siteId, sellerId, motivo
 * @returns {Object} Artículo con noticed, country, reported, sellerData, seller, status, etc.
 */
export function normalizeReportDataArticle(article) {
  if (!article) return null;
  const {
    item_id,
    title,
    id,
    current_status,
    fecha,
    auditor,
    seller_name,
    seller_id,
    currency,
    price,
    href,
    siteId,
    sellerId,
    motivo,
  } = article;

  const countryName = SITE_ID_TO_COUNTRY_NAME[siteId] || siteId || '';

  return {
    id,
    title,
    price,
    currency,
    href,
    siteId,
    sellerId,
    status: current_status,
    noticed: {
      noticeStatus: current_status,
      noticedAt: fecha,
    },
    country: {
      name: countryName,
    },
    reported: {
      author: {
        familyName: auditor || '',
        givenName: '',
      },
      code: motivo || '',
    },
    sellerData: {
      nickname: seller_name || '',
      address: {
        city: '',
        state: '',
      },
    },
    seller: {
      id: seller_id || sellerId || '',
    },
  };
}
